import BaseballPitchType from "../BaseballPitchType.js";

// see https://docs.google.com/document/d/1PszbMD2JgXitdGb3qnn7RrqXJokpWL1mOZDNbF3FNZI/edit#heading=h.l09ryso41p1l
// order, groups and colors based on: https://flightscope.atlassian.net/browse/FBW-163
const BaseballPitchTypeGroup = {
    all: {
        key: 'all',
        name: 'All',
        types: Object.values(BaseballPitchType).map( value => value.key )
    },
    fastballs: { key: 'fbg', name: 'Fastballs', results: [
        BaseballPitchType.FourSeamFastball.key, BaseballPitchType.TwoSeamFastball.key,
        BaseballPitchType.Sinker.key, BaseballPitchType.Cutter.key, 
        BaseballPitchType.Fastball.key
    ]},
    breaking: { key: 'bbg', name: 'Breaking Balls', results: [
        BaseballPitchType.Slider.key, BaseballPitchType.Curveball.key,
        BaseballPitchType.KnuckleCurve.key, BaseballPitchType.Slurve.key,
        BaseballPitchType.Screwball.key, BaseballPitchType.BreakingBall.key
    ]},
    changeup: { key: 'osg', name: 'Offspeed', results: [
        BaseballPitchType.Changeup.key, BaseballPitchType.CircleChangeup.key,
        BaseballPitchType.Splitter.key, BaseballPitchType.Forkball.key, 
        BaseballPitchType.Palmball.key, BaseballPitchType.Knuckleball.key,
        BaseballPitchType.Eephus.key, BaseballPitchType.Gyroball.key,
        BaseballPitchType.Offspeed.key
    ]},
    other: { key: 'otg', name: 'Neutral', results: [
        BaseballPitchType.Other.key, 
        BaseballPitchType.Unidentified.key, 
        BaseballPitchType.Pitchout.key  
    ]}
};

export default BaseballPitchTypeGroup;
